<template>
<div class="facilities-table-detail-row">
    <div class="flex">
        <div class="flex">
            <strong>Actions:</strong>
            <div class="flex ai-fs ml-3">
                <div class="flex ai-fs fd-c">
                    <button class="text" type="button" @click="onEditCycle">
                        <i class="material-icons">edit</i>
                        <span class="ml-1">Edit Cycle</span>
                    </button>

                    <button class="text" type="button" @click="onUploadTenants">
                        <i class="material-icons">cloud_upload</i>
                        <span class="ml-1">Import Tenants</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="as-c gray-divider ml-5 mr-5">&nbsp;</div>

        <div class="flex">
            <strong>Other:</strong>

            <div class="flex ai-fs ml-3">
                <div class="flex ai-fs fd-c">
                    <router-link :to="`/tenant-list?facility_number=${rowData.facility_number}&cycle_id=${rowData.id}`">
                        <i class="material-icons">people</i>
                        <span class="ml-1">View Tenants</span>
                    </router-link>
                    <button class="text danger" type="button" @click="onArchiveCycle">
                        <i class="material-icons">assignment_turned_in</i>
                        <span class="ml-1">Archive Cycle</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from "vue"
import EditCycleModal from "@/components/manage-cycles-page/EditCycleModal.vue"
import http from "@/http"
import dayjs from "dayjs"
import ImportTenantsModal from "@/components/manage-cycles-page/ImportTenantsModal.vue"

export default {
    name: "cycles-table-detail-row",

    props: {
        rowData: {
            required: true,
            type: Object
        },

        rowIndex: {
            type: Number
        }
    },

    data () {
        return {
        }
    },

    methods: {
        onEditCycle () {
            const componentConstructor = Vue.extend(EditCycleModal)

            this.$eventManager.emit("show-modal", {
                component: componentConstructor,
                props: {
                    cycle: this.rowData,
                    onSuccess: () => {
                        this.$eventManager.emit("update-cycles")
                    }
                }
            })
        },
        async onArchiveCycle () {
            const message = `Are you sure you want to archive cycle for ${this.rowData.facility_number}?`

            if (confirm(message)) {
                this.$loadingManager.show(`Archiving cycle for ${this.rowData.facility_number}...`)

                try {
                    const { data: { filename: fileKey } } = await http.post(`/api/cycles/${this.rowData.id}/archive`)

                    let downloadUrl = `${http.defaults.baseURL}/api/exports/download`
                    downloadUrl += `?file_key=${fileKey}&filename=${this.rowData.facility_number}_${dayjs().format("YYYY-MM-DD")}_export`

                    window.open(downloadUrl, "_blank")

                    this.$eventManager.emit("cycle-archive-success")
                } catch (ex) {
                    if (ex === undefined) {
                        this.$modalManager.add({ state: "bad", header: "Error", body: "Unexpected error!" })
                    } else if (ex.message) {
                        this.$modalManager.add({ state: "bad", header: "Error", body: ex.message })
                    } else {
                        this.$modalManager.add({ state: "bad", header: "Error", body: ex })
                    }
                } finally {
                    this.$loadingManager.hide()
                    window.location.reload()
                }
            }
        },
        onUploadTenants () {
            const componentConstructor = Vue.extend(ImportTenantsModal)

            this.$eventManager.emit("show-modal", {
                component: componentConstructor,
                events: {
                    "success": (uploadResponse) => {
                        this.$eventManager.emit("cycle-tenant-import", uploadResponse)
                        this.$eventManager.emit("update-cycles")
                    }
                },
                props: {
                    cycleId: this.rowData.id
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/manage-cycles-page/CyclesTableDetailRow.vue